import {
  initialState,
  Actions,
  State,
  GET_ALL_PAGOS,
  GET_ALL_PAGOS_SUCCESS,
  GET_ALL_PAGOS_ERROR,
  RESET_GET_ALL_PAGOS,
} from "../../types/pago/getAll";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_PAGOS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_PAGOS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_PAGOS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_PAGOS:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
